import { ROUTES } from '@sportninja/common/constants/app'

/**
 * Where a team's title in the panel header links to.
 *
 * Exactly the legacy Setup tab's "Open in new tab" link
 * (`pages/Schedule/ScheduleTree/TeamInfoPanel.jsx`): the team's Roster tab,
 * with `sn_schedule` set to the competition the page is showing (the root, not
 * the team's division) so the Team page opens on this competition's roster.
 */
export const teamRosterHref = (teamId: string, scheduleId: string): string =>
  `${ROUTES.TEAM_ROOT}/${teamId}/roster${
    scheduleId ? `?sn_schedule=${scheduleId}` : ''
  }`
